// extracted by css-extract-rspack-plugin
export default {"inputSection":"src-domain-components-system-package-version-about-section-systemPackageVersionAboutSection-module__inputSection-jbomtY","sectionTitle":"src-domain-components-system-package-version-about-section-systemPackageVersionAboutSection-module__sectionTitle-hghuUw"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"inputSection\":\"src-domain-components-system-package-version-about-section-systemPackageVersionAboutSection-module__inputSection-jbomtY\",\"sectionTitle\":\"src-domain-components-system-package-version-about-section-systemPackageVersionAboutSection-module__sectionTitle-hghuUw\"}";
        // 1793705033266
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  